// src/pages/Home.jsx
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import {
  FaCalendarAlt,
  FaPhoneAlt,
  FaCheckCircle,
  FaArrowRight,
  FaNotesMedical,
  FaPlusSquare,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaClock,
  FaBone,
  FaRunning,
  FaBrain,
  FaProcedures,
} from "react-icons/fa";

import TechIcon from "../assets/Icon (3).png";
import SanitizedIcon from "../assets/Icon (5).png";
import LicensedIcon from "../assets/Icon (6).png";
import GoogleIcon from "../assets/SVG.png";
import doctorImg from "../assets/doctor.jpeg";
import heroImage from "../assets/hero.jpeg";
import orthopedicImg from "../assets/our experience/Orthopedic Physio.jpeg";
import sportsImg from "../assets/our experience/Sports Injuries.jpeg";
import neuroImg from "../assets/our experience/Neuro Rehab.jpeg";
import postOpImg from "../assets/our experience/Post-Op Care.jpeg";

export default function Home() {
  const phoneNumber = "+919182643439";
  const whatsappLink = `https://wa.me/${phoneNumber.replace("+", "")}`;

  const services = [
    {
      title: "Orthopedic Physio",
      description:
        "Specialized care for joint pain, fractures, and ligament injuries.",
      img: orthopedicImg,
      icon: <FaBone size={28} color="#2563eb" />,
    },
    {
      title: "Sports Injuries",
      description:
        "Fast-track recovery protocols for athletes and active individuals.",
      img: sportsImg,
      icon: <FaRunning size={28} color="#16a34a" />,
    },
    {
      title: "Neuro Rehab",
      description: "Reclaiming mobility after stroke, Parkinson’s or SCI.",
      img: neuroImg,
      icon: <FaBrain size={28} color="#7c3aed" />,
    },
    {
      title: "Post-Op Care",
      description: "Guided recovery following knee or hip replacements.",
      img: postOpImg,
      icon: <FaProcedures size={28} color="#dc2626" />,
    },
  ];

  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "Back Pain Patient",
      quote:
        '"I had chronic back pain for 3 years. After just 5 sessions with Dr. Anusha, I am 90% pain-free. The personalized exercises really worked wonders!"',
      avatar:
        "https://thumbs.dreamstime.com/b/head-shot-portrait-happy-indian-man-posing-indoor-millennial-s-dressed-casual-blue-shirt-profile-picture-office-employee-355194436.jpg",
    },
    {
      name: "Sneha Reddy",
      role: "ACL Recovery",
      quote:
        '"The best physiotherapy clinic in Hyderabad. The care and attention they give is unmatched. Highly professional staff and clean environment."',
      avatar:
        "https://thumbs.dreamstime.com/b/cheerful-indian-girl-standing-home-office-looking-camera-cheerful-beautiful-indian-girl-student-professional-standing-168424419.jpg",
    },
    {
      name: "Vikram Verma",
      role: "Sports Injury",
      quote:
        '"Elite Care helped me get back on the cricket field after a shoulder injury. Their sports-specific rehab is top-notch. Thank you Team!"',
      avatar:
        "https://thumbs.dreamstime.com/b/mid-adult-indian-man-smiling-running-mature-fitness-listening-to-music-resting-jogging-happy-middle-eastern-feeling-219681121.jpg",
    },
  ];

  return (
    <>
      <Navbar />

      <style>{`
        *{
          box-sizing:border-box;
        }

        html{
          scroll-behavior:smooth;
        }

        body{
          overflow-x:hidden;
          background:#ffffff;
        }

        .home-page{
          width:100%;
          overflow-x:hidden;
          background:#ffffff;
        }

        .hero-section{
          width:100%;
          padding:40px 20px 30px;
          background:#f8f9fb;
        }

        .hero-wrap{
          max-width:1250px;
          margin:0 auto;
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:40px;
          align-items:center;
        }

        .hero-left h1{
          font-size:clamp(1.5rem, 3.5vw, 3.5rem);
          line-height:1.2;
          color:#1f2940;
          margin:0;
          font-family:Georgia, serif;
          font-weight:700;
          white-space: nowrap;
        }

        .hero-left .blue-text{
          color:#3b82f6;
        }

        .hero-left p{
          margin-top:24px;
          color:#7b8597;
          font-size:clamp(0.98rem, 2vw, 1.08rem);
          line-height:1.8;
          max-width:620px;
        }

        .hero-actions{
          display:flex;
          gap:16px;
          flex-wrap:wrap;
          margin-top:28px;
        }

        .hero-btn-green,
        .hero-btn-outline{
          border-radius:999px;
          padding:15px 24px;
          font-size:15px;
          font-weight:700;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          gap:10px;
          text-decoration:none;
          transition:all 0.3s ease;
          min-width:180px;
        }

        .hero-btn-green{
          background:#62d60f;
          color:#ffffff;
          box-shadow:0 10px 24px rgba(98,214,15,0.25);
        }

        .hero-btn-outline{
          background:#ffffff;
          color:#66b80f;
          border:2px solid #82c91e;
        }

        .hero-btn-green:hover,
        .hero-btn-outline:hover{
          transform:translateY(-3px);
        }

        .hero-trust{
          margin-top:28px;
          padding-top:18px;
          border-top:1px solid #e7ebf2;
          display:flex;
          align-items:center;
          gap:18px;
          flex-wrap:wrap;
        }

        .avatars{
          display:flex;
          align-items:center;
        }

        .avatars img{
          width:38px;
          height:38px;
          border-radius:50%;
          object-fit:cover;
          border:3px solid #ffffff;
          margin-left:-10px;
        }

        .avatars img:first-child{
          margin-left:0;
        }

        .trust-text{
          color:#8a94a6;
          font-size:13px;
          line-height:1.7;
        }

        .trust-stars{
          color:#f6b400;
          letter-spacing:2px;
          font-size:14px;
          display:block;
        }

        .hero-right{
          position:relative;
          display:flex;
          justify-content:center;
        }

        .hero-right img{
          width:100%;
          max-width:100%;
          height:auto;
          border-radius:26px;
          display:block;
          box-shadow:0 24px 50px rgba(15,23,42,0.16);
        }

        .hero-badge-card{
          position:absolute;
          bottom:18px;
          left:50%;
          transform:translateX(-50%);
          width:min(86%, 360px);
          background:rgba(255,247,240,0.96);
          padding:18px 20px;
          border-radius:18px;
          box-shadow:0 16px 30px rgba(15,23,42,0.16);
        }

        .hero-badge-card small{
          display:block;
          color:#82c91e;
          font-size:11px;
          font-weight:800;
          letter-spacing:1px;
          text-transform:uppercase;
          margin-bottom:8px;
        }

        .hero-badge-top{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:10px;
        }

        .hero-badge-top h3{
          margin:0;
          color:#1f2937;
          font-size:31px;
          font-weight:800;
        }

        .hero-badge-check{
          width:30px;
          height:30px;
          border-radius:50%;
          background:#d8f7b8;
          color:#63b80f;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .hero-progress{
          margin-top:14px;
          width:100%;
          height:8px;
          border-radius:999px;
          background:#d8dce4;
          overflow:hidden;
        }

        .hero-progress span{
          display:block;
          width:98%;
          height:100%;
          background:#62d60f;
        }

        .expert{
          width:100%;
          display:flex;
          gap:60px;
          align-items:center;
          justify-content:center;
          padding:80px 80px;
          background:#eef3f9;
          flex-wrap:wrap;
        }

        .expert-img{
          flex:1;
          min-width:320px;
          position:relative;
        }

        .expert-img img{
          width:100%;
          max-width:800px;
          border-radius:22px;
          box-shadow:0 20px 40px rgba(0,0,0,0.15);
          display:block;
        }

        .doctor-info{
          position:absolute;
          bottom:20px;
          left:20px;
          color:white;
          background: rgba(15, 23, 42, 0.7);
          backdrop-filter: blur(8px);
          padding: 16px 20px;
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.15);
          box-shadow: 0 8px 24px rgba(0,0,0,0.2);
        }

        .doctor-name {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
          letter-spacing: 0.5px;
        }

        .doctor-qual {
          display:block;
          font-size:13px;
          color:#86efac;
          font-weight:500;
        }
        
        .doctor-title {
          display:block;
          font-size:13px;
          color:#93c5fd;
          font-weight:500;
          margin-top: 2px;
        }

        .expert-content{
          flex:1;
          min-width:320px;
        }

        .expert-label{
          color:#22c55e;
          font-size:12px;
          font-weight:700;
          letter-spacing:1px;
          margin-bottom:10px;
          text-transform:uppercase;
        }

        .expert-content h2{
          font-size:42px;
          line-height:1.2;
          margin-bottom:20px;
          color:#1f2937;
          font-weight:800;
        }

        .blue{
          color:#2563eb;
        }

        .badges{
          display:flex;
          gap:10px;
          flex-wrap:wrap;
          margin-bottom:20px;
        }

        .badge{
          background:#f3f4f6;
          padding:6px 12px;
          border-radius:8px;
          font-size:13px;
          color:#374151;
          border:1px solid #e5e7eb;
        }

        .expert-text{
          color:#6b7280;
          line-height:1.8;
          margin-bottom:30px;
          font-size:15px;
        }

        .expert-cards{
          display:flex;
          gap:20px;
          flex-wrap:wrap;
          margin-bottom:30px;
        }

        .expert-card{
          flex:1;
          min-width:220px;
          background:white;
          padding:20px;
          border-radius:12px;
          box-shadow:0 10px 20px rgba(0,0,0,0.08);
        }

        .expert-card h4{
          margin:10px 0;
          color:#1f2937;
          font-size:18px;
        }

        .expert-card p{
          font-size:14px;
          color:#6b7280;
          line-height:1.8;
          margin:0;
        }

        .profile-btn{
          background:white;
          border:2px solid #2563eb;
          color:#2563eb;
          padding:12px 22px;
          border-radius:10px;
          font-weight:600;
          display:inline-flex;
          align-items:center;
          gap:8px;
          cursor:pointer;
          transition:all 0.3s ease;
        }

        .profile-btn:hover{
          background:#2563eb;
          color:white;
        }

        .advantages{
          background-color:#ffffff;
          color:#000000;
          padding:clamp(50px, 8vw, 90px) 20px;
          text-align:center;
        }

        .adv-small-title{
          color:#16a34a;
          font-size:12px;
          font-weight:600;
          letter-spacing:2px;
          margin-bottom:10px;
          text-transform:uppercase;
        }

        .advantages h2{
          font-size:clamp(1.8rem, 6vw, 3rem);
          margin:0 0 20px;
          color:#1f2937;
          font-weight:800;
        }

        .adv-desc{
          font-size:clamp(1rem, 3.5vw, 1.1rem);
          max-width:900px;
          margin:0 auto 56px;
          line-height:1.8;
          color:#333333;
        }

        .adv-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit, minmax(300px, 1fr));
          gap:30px;
          max-width:1200px;
          margin:0 auto;
        }

        .adv-card{
          background-color:#f8f9fa;
          padding:40px 25px;
          border-radius:16px;
          border:1px solid #e0e0e0;
          box-shadow:0 4px 12px rgba(0,0,0,0.08);
          transition:all 0.35s ease;
          cursor:pointer;
          text-align:left;
        }

        .adv-card:hover{
          transform:translateY(-10px);
          box-shadow:0 20px 40px rgba(59,130,246,0.18);
        }

        .icon-hover{
          display:inline-flex;
          align-items:center;
          justify-content:center;
          width:70px;
          height:70px;
          border-radius:16px;
          background:rgba(59,130,246,0.15);
          backdrop-filter:blur(8px);
          border:1px solid rgba(59,130,246,0.35);
          box-shadow:0 6px 20px rgba(59,130,246,0.16);
          margin-bottom:20px;
          transition:all 0.35s ease;
        }

        .adv-card:hover .icon-hover{
          transform:scale(1.1);
        }

        .icon-hover img{
          width:32px;
          display:block;
        }

        .adv-card h3{
          font-size:1.5rem;
          margin:0 0 12px;
          font-weight:600;
          color:#1f2937;
        }

        .adv-card p{
          color:#555;
          line-height:1.7;
          font-size:1rem;
          margin:0;
        }

        .adv-bottom{
          margin-top:70px;
          display:flex;
          flex-wrap:wrap;
          justify-content:space-between;
          align-items:center;
          max-width:980px;
          margin-left:auto;
          margin-right:auto;
          gap:30px;
        }

        .google-rating,
        .simple-info{
          display:flex;
          align-items:center;
          gap:12px;
        }

        .google-stars{
          color:#FFD700;
          font-size:18px;
          letter-spacing:2px;
        }

        .google-rating small{
          font-size:14px;
          color:#333;
        }

        .simple-info span{
          color:#333;
          font-size:14px;
          font-weight:500;
        }

        .treatments{
          padding:clamp(60px, 10vw, 100px) 20px;
          background-color:#ffffff;
          text-align:center;
        }

        .treatments-top{
          display:flex;
          justify-content:space-between;
          align-items:baseline;
          max-width:1200px;
          margin:0 auto clamp(20px, 4vw, 40px);
          flex-wrap:wrap;
          gap:20px;
          text-align:left;
        }

        .treatments-top-left{
          display:flex;
          flex-direction:column;
          align-items:flex-start;
        }

        .treatments-top-left .green-title{
          color:#22c55e;
          font-size:1rem;
          font-weight:600;
          margin-bottom:12px;
          text-transform:uppercase;
          letter-spacing:1px;
        }

        .treatments-top-left h2{
          font-size:clamp(2rem, 2vw, 2.5rem);
          font-weight:bold;
          color:#111827;
          margin:0;
          line-height:1.1;
        }

        .view-services{
          color:#3b82f6;
          font-size:1.1rem;
          font-weight:600;
          text-decoration:none;
          display:flex;
          align-items:center;
          gap:8px;
          white-space:nowrap;
        }

        .treatment-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit, minmax(260px, 1fr));
          gap:clamp(20px, 4vw, 32px);
          max-width:1400px;
          margin:0 auto;
        }

        .treatment-card{
          position:relative;
          border-radius:16px;
          overflow:hidden;
          height:420px;
          background-color:#000;
          box-shadow:0 10px 30px rgba(0,0,0,0.1);
          transition:all 0.35s ease;
          transform:translateY(0);
          cursor:pointer;
        }

        .treatment-card:hover{
          transform:translateY(-12px) scale(1.03);
          box-shadow:0 20px 50px rgba(0,0,0,0.18);
        }

        .card-main-img{
          width:100%;
          height:100%;
          object-fit:cover;
          transition:transform 0.5s ease;
        }

        .treatment-card:hover .card-main-img{
          transform:scale(1.08);
        }

        .overlay{
          position:absolute;
          inset:0;
          background:linear-gradient(to bottom, transparent 40%, rgba(0,0,0,0.75) 100%);
          transition:background 0.4s ease;
        }

        .treatment-card:hover .overlay{
          background:linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.65) 100%);
        }

        .icon-container{
          position:absolute;
          bottom:140px;
          left:24px;
          width:70px;
          height:70px;
          background-color:rgba(255,255,255,0.96);
          border-radius:20px;
          display:flex;
          align-items:center;
          justify-content:center;
          box-shadow:0 8px 20px rgba(0,0,0,0.18);
          transition:all 0.35s ease;
          z-index:2;
        }

        .treatment-card:hover .icon-container{
          transform:scale(1.12);
          background-color:#ffffff;
        }

        .icon-svg{
          display:flex;
          align-items:center;
          justify-content:center;
          transition:transform 0.4s ease;
        }

        .treatment-card:hover .icon-svg{
          transform:scale(1.1);
        }

        .treatment-content{
          position:absolute;
          bottom:24px;
          left:24px;
          right:24px;
          color:#ffffff;
          text-align:left;
          z-index:2;
        }

        .treatment-content h3{
          font-size:clamp(1.4rem, 4vw, 1.8rem);
          font-weight:700;
          margin:0 0 8px;
        }

        .treatment-content p{
          font-size:clamp(0.95rem, 3vw, 1.1rem);
          line-height:1.5;
          opacity:0.95;
          margin:0;
        }

        .testimonials{
          padding:clamp(60px, 10vw, 100px) 20px;
          background-color:#ffffff;
          text-align:center;
        }

        .testimonials h2{
          font-size:clamp(2.2rem, 6vw, 3.5rem);
          font-weight:bold;
          color:#111827;
          margin-bottom:16px;
        }

        .testimonials p.top-desc{
          font-size:clamp(1.05rem, 3vw, 1.25rem);
          color:#4b5563;
          max-width:800px;
          margin:0 auto 40px;
          line-height:1.6;
        }

        .testimonial-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit, minmax(320px, 1fr));
          gap:clamp(24px, 5vw, 40px);
          max-width:1200px;
          margin:0 auto;
        }

        .test-card{
          background-color:#ffffff;
          border-radius:16px;
          padding:clamp(32px, 6vw, 48px) 32px;
          box-shadow:0 10px 30px rgba(0,0,0,0.08);
          border:1px solid #e5e7eb;
          transition:all 0.35s ease;
          transform:translateY(0);
          cursor:pointer;
          position:relative;
          text-align:left;
        }

        .test-card:hover{
          transform:translateY(-8px);
          box-shadow:0 20px 50px rgba(0,0,0,0.12);
        }

        .testimonial-top{
          display:flex;
          align-items:center;
          gap:16px;
          margin-bottom:24px;
        }

        .testimonial-top img{
          width:64px;
          height:64px;
          border-radius:50%;
          object-fit:cover;
          border:3px solid #f3f4f6;
        }

        .testimonial-top h4{
          font-size:1.25rem;
          font-weight:600;
          color:#111827;
          margin:0;
        }

        .testimonial-top .role{
          font-size:1rem;
          color:#22c55e;
          font-weight:500;
          margin-top:4px;
        }

        .quote-mark-left{
          font-size:clamp(4rem, 12vw, 6rem);
          color:#e5e7eb;
          position:absolute;
          top:20px;
          left:24px;
          opacity:0.15;
          line-height:1;
        }

        .quote-mark-right{
          font-size:clamp(4rem, 12vw, 6rem);
          color:#e5e7eb;
          position:absolute;
          bottom:80px;
          right:24px;
          opacity:0.15;
          line-height:1;
          transform:rotate(180deg);
        }

        .test-card p.quote{
          font-size:clamp(1rem, 3vw, 1.125rem);
          line-height:1.7;
          color:#374151;
          margin-bottom:24px;
          font-style:italic;
          position:relative;
          z-index:2;
        }

        .test-stars{
          font-size:1.5rem;
          color:#fbbf24;
          letter-spacing:2px;
        }

        .contact-section{
          padding:clamp(60px, 8vw, 120px) 20px;
          background-color:#ffffff;
          color:#111827;
        }

        .contact-wrap{
          max-width:1200px;
          margin:0 auto;
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:clamp(40px, 6vw, 80px);
          align-items:center;
        }

        .contact-left h2{
          font-size:clamp(2.2rem, 6vw, 3.5rem);
          font-weight:500;
          margin-bottom:clamp(32px, 6vw, 56px);
          color:#111827;
        }

        .contact-row{
          display:flex;
          gap:18px;
          margin-bottom:36px;
          align-items:flex-start;
          transition:transform 0.3s ease;
        }

        .contact-row:hover{
          transform:translateX(6px);
        }

        .contact-icon-box{
          width:50px;
          height:50px;
          border-radius:14px;
          background:#f3f4f6;
          display:flex;
          align-items:center;
          justify-content:center;
          flex-shrink:0;
        }

        .contact-row svg{
          width:26px;
          height:26px;
          color:black;
          transition:transform 0.3s ease;
        }

        .contact-row:hover svg{
          transform:scale(1.2);
          color:#22c55e;
        }

        .contact-row h4{
          font-size:1.35rem;
          font-weight:600;
          margin:0 0 7px;
          color:black;
        }

        .contact-row p{
          line-height:1.7;
          color:#4b5563;
          margin:0;
        }

        .contact-buttons{
          display:flex;
          flex-wrap:wrap;
          gap:16px;
          margin-top:10px;
        }

        .contact-btn{
          padding:14px 28px;
          border-radius:50px;
          font-size:1rem;
          font-weight:600;
          text-decoration:none;
          display:inline-flex;
          align-items:center;
          gap:10px;
          transition:all .3s ease;
        }

        .contact-btn.whatsapp{
          background:#25D366;
          color:white;
        }

        .contact-btn.call{
          background:#3b82f6;
          color:white;
        }

        .contact-btn:hover{
          transform:translateY(-3px);
          box-shadow:0 8px 20px rgba(0,0,0,0.16);
        }

        .map-box{
          position:relative;
          border-radius:16px;
          overflow:hidden;
          box-shadow:0 10px 30px rgba(0,0,0,0.12);
          transition:transform .4s ease;
        }

        .map-box:hover{
          transform:scale(1.03);
        }

        .map-box img{
          width:100%;
          display:block;
        }

        .map-btn{
          position:absolute;
          bottom:24px;
          right:24px;
          background:white;
          padding:12px 24px;
          border-radius:50px;
          font-weight:600;
          text-decoration:none;
          color:#111827;
          box-shadow:0 4px 16px rgba(0,0,0,0.18);
          transition:all .3s ease;
        }

        .map-btn:hover{
          transform:scale(1.05);
          background:#f3f4f6;
        }

        @media(max-width:1100px){
          .hero-wrap{
            grid-template-columns:1fr;
            text-align:center;
          }

          .hero-left p{
            margin-left:auto;
            margin-right:auto;
          }

          .hero-actions,
          .hero-trust{
            justify-content:center;
          }

          .hero-right img{
            height:500px;
          }
        }

        @media(max-width:1024px){
          .contact-wrap{
            grid-template-columns:1fr;
          }

          .contact-left{
            text-align:center;
          }

          .contact-row{
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .contact-buttons{
            justify-content:center;
          }
        }

        @media(max-width:900px){
          .expert{
            padding:50px 20px;
            flex-direction:column;
            text-align:center;
          }

          .expert-content h2{
            font-size:32px;
          }

          .expert-cards{
            justify-content:center;
          }

          .profile-btn{
            margin:auto;
          }
        }

        @media(max-width:768px){
          .hero-left h1{
            font-size:clamp(1.2rem, 7vw, 2.5rem);
          }

          .hero-right img{
            height:380px;
          }

          .hero-actions{
            flex-direction:column;
            align-items:center;
          }

          .hero-btn-green,
          .hero-btn-outline{
            width:100%;
            max-width:320px;
          }

          .hero-badge-card{
            width:min(92%, 320px);
          }

          .hero-badge-top h3{
            font-size:24px;
          }

          .adv-bottom{
            justify-content:center;
            text-align:center;
          }

          .treatments-top{
            flex-direction:column;
            align-items:flex-start;
          }

          .treatments-top-left h2{
            font-size:clamp(1.8rem, 8vw, 2.6rem) !important;
          }

          .testimonials h2{
            font-size:clamp(1.9rem, 8vw, 2.8rem);
          }

          .contact-left h2{
            font-size:clamp(1.9rem, 8vw, 2.8rem);
          }

          .contact-buttons{
            flex-direction:column;
            align-items:center;
          }

          .contact-btn{
            width:100%;
            justify-content:center;
            max-width:320px;
          }

          .map-btn{
            bottom:16px;
            right:16px;
            padding:10px 18px;
            font-size:14px;
          }
        }

        @media(max-width:480px){
          .hero-section{
            padding:28px 16px 24px;
          }

          .hero-right img{
            height:320px;
            border-radius:20px;
          }

          .expert-img img{
            max-width:100%;
          }

          .expert-content h2{
            font-size:28px;
          }

          .adv-card,
          .test-card{
            padding:24px 18px;
          }

          .treatment-card{
            height:340px;
          }

          .icon-container{
            bottom:120px;
            left:18px;
            width:58px;
            height:58px;
            border-radius:16px;
          }

          .treatment-content{
            left:18px;
            right:18px;
          }
      `}</style>

      <div className="home-page">
        <section className="hero-section">
          <div className="hero-wrap">
            <div className="hero-left">
              <h1>
                Pain Took Control of
                <br />
                <span className="blue-text">Your Life.</span>
                <br />
                We Help You Take It
                <br />
                <span className="blue-text">Back.</span>
              </h1>

              <p>
                Advanced Physiotherapy & Rehabilitation in Kukatpally,
                Hyderabad – Personalized Care That Gets You Back to Work,
                Sports & Daily Life Faster.
              </p>

              <div className="hero-actions">
                <a
                  href="/book-appointment"
                  className="hero-btn-green"
                >
                  <FaCalendarAlt />
                  Book Appointment
                </a>

                <a href={`tel:${phoneNumber}`} className="hero-btn-outline">
                  <FaPhoneAlt />
                  Call Now
                </a>
              </div>

              <div className="hero-trust">
                <div className="avatars">
                  <img
                    src="https://randomuser.me/api/portraits/women/44.jpg"
                    alt="patient"
                  />
                  <img
                    src="https://randomuser.me/api/portraits/men/32.jpg"
                    alt="patient"
                  />
                  <img
                    src="https://randomuser.me/api/portraits/women/65.jpg"
                    alt="patient"
                  />
                </div>

                <div className="trust-text">
                  <span className="trust-stars">★★★★★</span>
                  Trusted by 2,000+ Patients
                </div>
              </div>
            </div>

            <div className="hero-right">
              <img
                src={heroImage}
                alt="physiotherapy hero"
              />

              <div className="hero-badge-card">
                <small>Success Rate</small>

                <div className="hero-badge-top">
                  <h3>98% Recovery</h3>
                  <div className="hero-badge-check">
                    <FaCheckCircle />
                  </div>
                </div>

                <div className="hero-progress">
                  <span />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="expert" id="team-section">
          <div className="expert-img">
            <img src={doctorImg} alt="doctor" />

            <div className="doctor-info">
              <div className="doctor-name">Dr. T. Anusha</div>
              <div className="doctor-qual">BPT (NIMS), MIAP, CKTP</div>
              <div className="doctor-title">Consultant Physiotherapist | 10+ Years of Experience</div>
            </div>
          </div>

          <div className="expert-content" id="about-section">
            <div className="expert-label">MEET YOUR EXPERT</div>

            <h2>
              Leading with | <span className="blue">Clinical Excellence</span>
            </h2>

            <div className="badges">
              <div className="badge">BPT (Bachelor of Physiotherapy)</div>
              <div className="badge">MIAP</div>
              <div className="badge">Certified Kinesio Taping Practitioner</div>
            </div>

            <p className="expert-text">
              Elite Care offers personalized physiotherapy treatments with a
              patient-first approach, combining clinical expertise, modern
              rehabilitation techniques, and compassionate care.
            </p>

            <div className="expert-cards">
              <div className="expert-card">
                <FaNotesMedical size={24} color="#22c55e" />
                <h4>Precise Diagnosis</h4>
                <p>
                  Evidence-based assessments to identify the root cause and plan
                  effective treatment.
                </p>
              </div>

              <div className="expert-card">
                <FaPlusSquare size={24} color="#2563eb" />
                <h4>Holistic Recovery</h4>
                <p>
                  Complete rehabilitation support focused on pain relief,
                  mobility, and strength.
                </p>
              </div>
            </div>

            <button className="profile-btn">
              Read Full Profile <FaArrowRight />
            </button>
          </div>
        </section>

        <section className="advantages">
          <div className="adv-small-title">WHY CHOOSE US</div>

          <h2>Healing with Precision & Compassion</h2>

          <p className="adv-desc">
            From pain relief to advanced rehabilitation, we provide focused
            physiotherapy care with trusted expertise, modern methods, and a
            welcoming healing environment.
          </p>

          <div className="adv-grid">
            <div className="adv-card">
              <div className="icon-hover">
                <img src={TechIcon} alt="Advanced equipment" />
              </div>
              <h3>Advanced Techniques</h3>
              <p>
                Modern treatment methods designed to speed up recovery and
                improve movement.
              </p>
            </div>

            <div className="adv-card">
              <div className="icon-hover">
                <img src={SanitizedIcon} alt="Sanitized clinic" />
              </div>
              <h3>Sanitized Clinic</h3>
              <p>
                Clean, hygienic, and comfortable spaces created for safe patient
                care.
              </p>
            </div>

            <div className="adv-card">
              <div className="icon-hover">
                <img src={LicensedIcon} alt="Licensed specialist" />
              </div>
              <h3>Certified Expertise</h3>
              <p>
                Skilled professionals delivering trusted, personalized treatment
                plans.
              </p>
            </div>
          </div>

          <div className="adv-bottom">
            <div className="google-rating">
              <img src={GoogleIcon} alt="Google" style={{ width: "26px" }} />
              <div>
                <div className="google-stars">★★★★★</div>
                <small>Rated highly by our happy patients</small>
              </div>
            </div>

            <div className="simple-info">
              <img src={SanitizedIcon} alt="Safe care" style={{ width: "24px" }} />
              <span>Trusted & Safe Care</span>
            </div>
          </div>
        </section>

        <section className="treatments" id="services-section">
          <div className="treatments-top">
            <div className="treatments-top-left">
              <div className="green-title">OUR EXPERTISE</div>

              <h2>
                Comprehensive
                <br />
                Specialized Treatments
              </h2>
            </div>

            <a href="/services" className="view-services">
              View All Services →
            </a>
          </div>

          <div className="treatment-grid">
            {services.map((service, index) => (
              <div key={index} className="treatment-card">
                <img
                  src={service.img}
                  alt={service.title}
                  className="card-main-img"
                />

                <div className="overlay" />

                <div className="icon-container">
                  <div className="icon-svg">{service.icon}</div>
                </div>

                <div className="treatment-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="testimonials">
          <h2>Stories of Recovery</h2>

          <p className="top-desc">
            Our patients trust us for effective treatment, compassionate care,
            and real recovery results.
          </p>

          <div className="testimonial-grid">
            {testimonials.map((item, index) => (
              <div key={index} className="test-card">
                <div className="quote-mark-left">“</div>

                <div className="testimonial-top">
                  <img src={item.avatar} alt={item.name} />
                  <div>
                    <h4>{item.name}</h4>
                    <div className="role">{item.role}</div>
                  </div>
                </div>

                <p className="quote">{item.quote}</p>

                <div className="test-stars">★★★★★</div>

                <div className="quote-mark-right">“</div>
              </div>
            ))}
          </div>
        </section>

        <section className="contact-section" id="contact-section">
          <div className="contact-wrap">
            <div className="contact-left">
              <h2>Contact Us</h2>

              <div className="contact-row">
                <div className="contact-icon-box">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h4>Address</h4>
                  <p>
                    Plot No. 309, Flat No. 202, 2nd Floor,
                    <br />
                    Road No. 6, Vivekananda Nagar Colony,
                    <br />
                    Kukatpally, Hyderabad – 500072
                  </p>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-box">
                  <FaPhoneAlt />
                </div>
                <div>
                  <h4>Phone</h4>
                  <p>+91 9182643439</p>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-box">
                  <FaClock />
                </div>
                <div>
                  <h4>Opening Hours</h4>
                  <p>Mon - Sun: 9:00 AM - 9:00 PM</p>
                </div>
              </div>

              <div className="contact-buttons">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-btn whatsapp"
                >
                  <FaWhatsapp />
                  WhatsApp Now
                </a>

                <a href={`tel:${phoneNumber}`} className="contact-btn call">
                  <FaPhoneAlt />
                  Call Now
                </a>
              </div>
            </div>

            <div className="map-box" style={{ minHeight: '600px' }}>
              <iframe
                src="https://maps.google.com/maps?q=EliteCare+Physiotherapy+and+Rehabilitation+Centre,+Kukatpally,+Hyderabad&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps Location"
              ></iframe>
              {/* <a
                href={googleMapsLink}
                target="_blank"
                rel="noreferrer"
                className="map-btn"
              >
                Open in Maps
              </a> */}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}